import { CheckCircleIcon, CircleDashedIcon, EyeIcon, XIcon } from '@phosphor-icons/react'

import { statuses } from '@/returns/constants'

export const itemStatusLabels = {
  [statuses.accepted]: 'Aceptado',
  [statuses.rejected]: 'Rechazado',
  [statuses.forReview]: 'Por revisar',
  [statuses.inProgress]: 'Pendiente',
}

export const getItemStatusChips = theme => {
  return {
    [statuses.accepted]: {
      Icon: CheckCircleIcon,
      backgroundColor: theme.colors.success.surface,
      color: theme.colors.success.onSurface,
    },
    [statuses.rejected]: {
      Icon: XIcon,
      backgroundColor: theme.colors.danger.surface,
      color: theme.colors.danger.onSurface,
    },
    [statuses.forReview]: {
      Icon: EyeIcon,
      backgroundColor: theme.colors.warning.surface,
      color: theme.colors.warning.onSurface,
    },
    [statuses.inProgress]: {
      Icon: CircleDashedIcon,
      backgroundColor: theme.colors.disabled.surface,
      color: theme.colors.text.muted,
    },
  }
}
